import { IconProvider } from '../../../../../shared/icon/icon'

// The fleet-wide provider pages -- domains, health, findings, credential
// notifications, jobs, connect -- live at paths that are SIBLINGS of the
// provider list (/admin/sso/jobs next to /admin/sso/connections) rather
// than descendants of it. Breadcrumb nesting otherwise falls out of React
// Router v5's non-exact matching, which only mounts an ancestor crumb for a
// descendant path, so each of these showed a bare one-item trail ("JOBS")
// despite only being reachable through the provider section's own menu.
//
// Handing them the section entry explicitly is what BreadcrumbView's `parent`
// is for. The url is the list page, so the first crumb navigates back to
// exactly where the user came from.
export const PROVIDER_SECTION_BREADCRUMB = { url: '/admin/sso/connections', text: 'SSO connections', Icon: IconProvider }
